import React from "react";
import {} from "../redux/actions";
import { connect } from "react-redux";
import { selectEmployeesForFocussedDay } from "../redux/selectors";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Avatar from "@material-ui/core/Avatar";
import Person from "@material-ui/icons/Person";
import ListSubheader from "@material-ui/core/ListSubheader";

class EmployeeList extends React.Component {
    render() {
        return (
            <React.Fragment>
                <List subheader={<ListSubheader>Occupied</ListSubheader>}>
                    {null ||
                        this.props.employees.occupied.map((u, i) => {
                            return (
                                <React.Fragment key={i}>
                                    <div
                                        draggable
                                        onDragStart={() => {
                                            this.props.onDragStart("employees", u);
                                        }}
                                        onDragEnd={() => {
                                            this.props.onDragEnd();
                                        }}
                                        style={{ cursor: "grab" }}
                                    >
                                        <ListItem key={i}>
                                            <Avatar>
                                                <Person />
                                            </Avatar>
                                            <ListItemText primary={u.name} />
                                        </ListItem>
                                    </div>
                                </React.Fragment>
                            );
                        })}
                </List>
                <List subheader={<ListSubheader>Unoccupied</ListSubheader>}>
                    {null ||
                        this.props.employees.unoccupied.map((u, i) => {
                            return (
                                <React.Fragment key={i}>
                                    <div
                                        draggable
                                        onDragStart={() => {
                                            this.props.onDragStart("employees", u);
                                        }}
                                        onDragEnd={() => {
                                            this.props.onDragEnd();
                                        }}
                                        style={{ cursor: "grab" }}
                                    >
                                        <ListItem key={i}>
                                            <Avatar>
                                                <Person />
                                            </Avatar>
                                            <ListItemText primary={u.name} />
                                        </ListItem>
                                    </div>
                                </React.Fragment>
                            );
                        })}
                </List>
            </React.Fragment>
        );
    }
}

export default connect(
    store => {
        return { employees: selectEmployeesForFocussedDay(store) };
    },
    {}
)(EmployeeList);
